import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Library from "./components/Library";
import StyleGuide from "./components/StyleGuide";
import Popular from "./components/Popular";
import Wiki from "./components/Wiki";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main className="bg-background-50">
      <Navbar />
      <Hero query={query} onQueryChange={setQuery} />
      <Library query={query} onQueryChange={setQuery} />
      <StyleGuide />
      <Popular />
      <Wiki />
      <Faq />
      <About />
      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        </button>
      )}
    </main>
  );
}